import type { FormPage } from "@/components/features/FormBuilder/types/form.types";

// A new form is only worth saving once it holds a question. Naming a page or a
// section, or adding an empty one, changes the JSON but adds nothing to keep.
export function hasFormContent(pages: FormPage[]): boolean {
  return pages.some((page) => page.sections.some((section) => section.questions.length > 0));
}
